import React from 'react';
import PasswordReset from '../Components/Users/PasswordReset';



export function ForgotPassword() { 

    return (
      <>  
        <PasswordReset />
      </>
);
   };

